module.exports = __webpack_public_path__ + "img/tk.fce85915.svg";